<template>
    <SJMMall>
        <div class="wrap">
            <img class="errImg" src="~@/assets/img/error/error.jpg"/>
        </div>
    </SJMMall>
</template>

<script>
    export default {
        name: 'Error',
        mounted() {
            this.$setTimeout(() => {
                this.$router.push('/');
            },3000);
        }
    };
</script>

<style scoped>
    .wrap {
        position: relative;
        overflow: hidden;
    }

    .wrap .errImg {
        position: relative;
        float: left;
        width: 100%;
        height: auto;
    }
</style>
